import gql from "graphql-tag";

export const MY_HR_CONTRACT_SUBSCRIPTION = gql`
  subscription contractsSubscription {
    contractsSubscription
  }
`;
